<header class="flex-none w-full px-6 overflow-hidden [scrollbar-gutter:stable]">
  <div class="max-w-[1120px] mx-auto py-2 border-b border-solid border-neutral-20">
    <div class="flex items-end justify-between gap-4 flex-wrap">
      <div class="flex flex-col gap-1">
        <h5 class="m-0 flex items-center gap-2.5">
          {{ 'actionsInbox.inbox.title' | translate }}
          @if (store.waitingCount() > 0) {
            <span
              class="text-caption bg-primary-100 text-forest-green-100 rounded-full px-[9px] py-px font-bold"
            >
              {{ store.waitingCount() }}
            </span>
          }
        </h5>
        <p class="m-0 text-body-2 text-neutral-60">
          @if (store.waitingCount() === 0) {
            {{ 'actionsInbox.inbox.nothingWaiting' | translate }}
          } @else {
            {{
              (store.clientCount() === 1
                ? 'actionsInbox.inbox.waitingOneClient'
                : 'actionsInbox.inbox.waiting'
              )
                | translate
                  : { count: store.waitingCount(), clients: store.clientCount() }
            }}
          }
        </p>
      </div>
      <span class="text-caption text-neutral-60 flex items-center gap-1.5">
        <span class="fa-icons icon-regular icon-shield-check icon-14"></span>
        {{ 'actionsInbox.inbox.trust' | translate }}
      </span>
    </div>
  </div>
</header>

<section class="flex-1 min-h-0 overflow-y-auto [scrollbar-gutter:stable] px-6">
  <div class="max-w-[1120px] mx-auto pt-4 pb-16">
    <div
      class="bg-white border border-solid border-neutral-20 rounded shadow-card px-5 pt-3 pb-5"
    >
      <kendo-tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab
          [title]="
            'actionsInbox.inbox.tabReview'
              | translate: { count: store.waitingCount() }
          "
          [selected]="tab() === 'review'"
        >
          <ng-template kendoTabContent>
            <div class="flex flex-col gap-3.5 pt-4">
              <ng-container *ngTemplateOutlet="filters" />

              @if (store.loadError()) {
                <ng-container *ngTemplateOutlet="loadFailed" />
              } @else if (store.loading() && reviewCards().length === 0) {
                <ng-container *ngTemplateOutlet="loading" />
              } @else if (reviewCards().length === 0) {
                <div
                  class="border border-dashed border-neutral-40 rounded px-7 py-9 text-center flex flex-col items-center gap-2"
                >
                  <span
                    class="bg-bush-green-10 text-bush-green-140 rounded-full w-11 h-11 grid place-items-center"
                  >
                    <span
                      class="fa-icons icon-regular icon-inbox icon-20"
                    ></span>
                  </span>
                  <span class="subtitle-1 text-neutral-90">
                    {{ 'actionsInbox.inbox.reviewEmptyTitle' | translate }}
                  </span>
                  <span class="text-body-2 text-neutral-60 max-w-[420px]">
                    {{ 'actionsInbox.inbox.emptyBody' | translate }}
                  </span>
                </div>
              } @else {
                <div class="flex flex-col gap-3">
                  @for (action of reviewCards(); track action.id) {
                    <maximizer-action-card
                      [action]="action"
                      [expanded]="isOpen(action.id)"
                      [payloadError]="store.payloadErrors()[action.id] ?? null"
                      (expandedChange)="setOpen(action.id, $event)"
                      (retry)="store.expand($event)"
                      (approve)="onApprove($event)"
                      (reject)="onReject($event)"
                    />
                  }
                </div>
              }
            </div>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab
          [title]="
            'actionsInbox.inbox.tabDone'
              | translate: { count: store.doneCount() }
          "
          [selected]="tab() === 'done'"
        >
          <ng-template kendoTabContent>
            <div class="flex flex-col gap-3.5 pt-4">
              <ng-container *ngTemplateOutlet="filters" />

              @if (store.loadError()) {
                <ng-container *ngTemplateOutlet="loadFailed" />
              } @else if (store.loading() && doneRows().length === 0) {
                <ng-container *ngTemplateOutlet="loading" />
              } @else if (doneRows().length === 0) {
                <div
                  class="border border-dashed border-neutral-40 rounded px-7 py-9 text-center flex flex-col items-center gap-2"
                >
                  <span
                    class="bg-neutral-10 text-neutral-60 rounded-full w-11 h-11 grid place-items-center"
                  >
                    <span
                      class="fa-icons icon-regular icon-clock-rotate-left icon-20"
                    ></span>
                  </span>
                  <span class="subtitle-1 text-neutral-90">
                    {{ 'actionsInbox.inbox.doneEmptyTitle' | translate }}
                  </span>
                  <span class="text-body-2 text-neutral-60 max-w-[420px]">
                    {{ 'actionsInbox.inbox.doneEmptyBody' | translate }}
                  </span>
                </div>
              } @else {
                <kendo-grid [kendoGridBinding]="doneRows()" class="no-border">
                  <kendo-grid-column
                    field="action.title"
                    [title]="'actionsInbox.done.colAction' | translate"
                  >
                    <ng-template kendoGridCellTemplate let-row>
                      <span class="flex items-center gap-2.5">
                        <span
                          class="flex-none w-7 h-7 rounded-md grid place-items-center"
                          [class]="tileClass(row.meta)"
                        >
                          <span
                            class="fa-icons icon-regular icon-14"
                            [class]="'icon-' + row.meta.icon"
                          ></span>
                        </span>
                        <span class="flex flex-col">
                          <span class="subtitle-2 text-neutral-90">
                            {{ row.action.title }}
                          </span>
                          <span class="text-caption text-neutral-60">
                            {{ row.meta.labelKey | translate }} ·
                            {{ row.action.recipe }}
                          </span>
                        </span>
                      </span>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column
                    field="action.result"
                    [title]="'actionsInbox.done.colOutcome' | translate"
                  >
                    <ng-template kendoGridCellTemplate let-row>
                      <span class="flex flex-col items-start gap-1">
                        <span
                          class="text-caption rounded-full px-2 py-px font-medium"
                          [class]="
                            row.ok
                              ? 'bg-bush-green-10 text-bush-green-140'
                              : 'bg-error-0 text-error-100'
                          "
                        >
                          {{
                            (row.ok
                              ? 'actionsInbox.done.statusDone'
                              : row.failed
                                ? 'actionsInbox.done.statusFailed'
                                : 'actionsInbox.done.statusRejected'
                            ) | translate
                          }}
                        </span>
                        <span class="text-body-2 text-neutral-90">
                          @if (row.ok) {
                            {{ row.action.result }}
                          } @else if (row.failed) {
                            {{
                              row.action.failureReason ??
                                ('actionsInbox.footer.failed' | translate)
                            }}
                          } @else if (row.action.decision?.reason) {
                            {{
                              'actionsInbox.done.reasonQuoted'
                                | translate
                                  : { reason: row.action.decision.reason }
                            }}
                          } @else {
                            {{ 'actionsInbox.done.noReason' | translate }}
                          }
                        </span>
                      </span>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column
                    field="action.decision.at"
                    [title]="'actionsInbox.done.colDecided' | translate"
                    [width]="260"
                  >
                    <ng-template kendoGridCellTemplate let-row>
                      <span class="flex flex-col">
                        <span class="text-body-2 text-neutral-90">
                          {{
                            (row.ok || row.failed
                              ? 'actionsInbox.done.approvedBy'
                              : 'actionsInbox.done.rejectedBy'
                            )
                              | translate
                                : {
                                    by: row.action.decision?.by,
                                    at:
                                      row.action.decision?.at
                                      | date: 'MMM d, h:mm a',
                                  }
                          }}
                        </span>
                        <span class="text-caption text-neutral-60">
                          {{
                            'actionsInbox.trigger.' + row.action.source.trigger
                              | translate
                          }}
                          · {{ row.action.source.label }}
                        </span>
                      </span>
                    </ng-template>
                  </kendo-grid-column>
                </kendo-grid>
              }
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </div>
</section>

<ng-template #loading>
  <span class="text-body-2 text-neutral-60 py-9 text-center">
    {{ 'actionsInbox.inbox.loading' | translate }}
  </span>
</ng-template>

<ng-template #loadFailed>
  <div
    class="px-7 py-9 text-center flex flex-col items-center gap-2"
    role="alert"
  >
    <span class="subtitle-1 text-neutral-90">
      {{ 'actionsInbox.inbox.loadFailedTitle' | translate }}
    </span>
    <span class="text-body-2 text-neutral-60">
      {{ 'actionsInbox.inbox.loadFailedMessage' | translate }}
    </span>
    <button kendoButton themeColor="secondary" (click)="store.load()">
      {{ 'actionsInbox.inbox.retry' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #filters>
  <div class="flex items-center gap-2.5 flex-wrap">
    <kendo-buttongroup selection="single">
      <button
        kendoButton
        type="button"
        [toggleable]="true"
        [selected]="filter() === 'all'"
        (click)="filter.set('all')"
      >
        {{ 'actionsInbox.inbox.filterAll' | translate }}
      </button>
      @for (type of filterTypes(); track type) {
        <button
          kendoButton
          type="button"
          [toggleable]="true"
          [selected]="filter() === type"
          (click)="filter.set(type)"
        >
          {{ metaOf(type).labelKey | translate }}
        </button>
      }
    </kendo-buttongroup>
    <button
      kendoButton
      type="button"
      fillMode="flat"
      size="small"
      class="ml-auto text-caption text-neutral-60"
      [iconClass]="
        'fa-icons icon-solid icon-14 ' +
        (sortOrder() === 'newest'
          ? 'icon-arrow-down-wide-short'
          : 'icon-arrow-up-short-wide')
      "
      [attr.aria-label]="'actionsInbox.inbox.sortToggle' | translate"
      (click)="toggleSort()"
    >
      {{
        (sortOrder() === 'newest'
          ? 'actionsInbox.inbox.newestFirst'
          : 'actionsInbox.inbox.oldestFirst'
        ) | translate
      }}
    </button>
    <button
      kendoButton
      type="button"
      themeColor="primary"
      fillMode="flat"
      [disabled]="store.loading()"
      (click)="store.load()"
    >
      <span class="fa-icons icon-solid icon-14 icon-refresh mr-1"></span>
      {{ 'actionsInbox.inbox.refresh' | translate }}
    </button>
  </div>
</ng-template>
